<template>
	<div class="header-page">
    <div class="header-content" @touchmove.prevent>
        <div class="disflex" >
          <a class="logo" href="/">
            <img  src="static/images/logo2.png" />
          </a>
<!--          <div class="sign ac" @click="getMenu('DailyLogin')">-->
<!--            <img class="sign-img" src="static/images/7-days-login.png" />-->
<!--          </div>-->
          <div class="account ac" @click="getMenu('myAccount')" >
            <img class="account-img" style="margin-left: 220px"  :src="avatar" />
          </div>
        </div>
    </div>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
      props: ['message'],
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              info:{},
              isShow:false,
              isActive:false,
              isShowMenu:false,
              isLogin:false,
              isEnShow:false,
              lang:'',
              isShowLang:'bur',
              avatar: "../../static/images/account.png",
            }
        },
        created(){
          if(localStorage.getItem('lang')){
            this.isShowLang = localStorage.getItem('lang')
          }
          // this.avatar = "../../static/images/account.png";
        },
		methods: {
      getLan(){
        let that = this
        that.$refs.imgDialog.showMaskFun();
      },
      closeTmgDialog(){
        this.$refs.imgDialog.closeMask();
      },

      getLang(type,lang){
        if(type==1){
          localStorage.setItem('lang',this.lang)
          location.reload()
        }else{
          this.isShowLang = lang
          this.lang = lang
        }
      },
      getMenu(url){
          this.isShowMenu = url
          let that = this
          setTimeout(function(){
            that.$router.push({path:url,query:{url:url}});
          },500);
      },
			getAcount(){
				let that =this;
			  this.isActive = true;
        this.getInfo()
			},
      getShowLogin(){
        this.$router.push({path:'/login'})
      },
      unSubscribe(){
      	let that =this;
      	that.$parent.$parent.loadModal(true);
      	that.$api.post('api/user/unsub',null,r =>{
      		that.$parent.$parent.returnCode(r,function(){
      	    that.$parent.$parent.loadModal(false);
            that.$utils.alertText(r.msg,80);
      	    localStorage.removeItem('token')
      	    localStorage.removeItem('mobile')
            // that.$router.push({path:'/login'});
            window.location.href = "https://snapai.asia/"
      	  });
      	})
      },
      getInfo (){
        let that =this;
        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/info',null,r =>{
        	that.$parent.$parent.returnCode(r,function(){
            that.info = r.data
            localStorage.setItem('info',r.data.score)
            localStorage.setItem('int_url',r.data.invite_url)
            localStorage.setItem('avatar',r.data.avatar)
            that.$parent.$parent.loadModal(false);
          });
        })
      },
      goBack() {
        if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          window.location.href = "mytel://back";
        }else if (/Android/i.test(navigator.userAgent)) {
          window.location.href = "mytel://back";
        }else{
          window.location.href = "mytel://back";
        }
      }
		}
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue